import { Button } from '@/components/ui/button';

import { usePiusEnabled } from './usePiusEnabled';

/**
 * Destructive "Disable Pius Discovery" control, shared by the customer drawer and the
 * seed drawer's Discovery tab. Renders nothing when Pius is not enabled for `email`.
 */
export function PiusDisableButton({ email }: { email: string }) {
  const { isPiusEnabled, isDisabling, handleDisable } = usePiusEnabled(email);

  if (!isPiusEnabled) return null;

  return (
    <div className="flex justify-end">
      <Button
        variant="destructive"
        size="sm"
        onClick={handleDisable}
        disabled={isDisabling}
      >
        {isDisabling ? 'Disabling...' : 'Disable Pius Discovery'}
      </Button>
    </div>
  );
}
